import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "react-bootstrap";
import { listMyOrders } from "../actions/orderActions";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { formatPrice } from "../utils/formatPrice.js";
import ReactPaginate from "react-paginate";

const MyOrders = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);

  const { orders, loading, error, totalOrders, pages } = useSelector(
    (state) => state.myOrders
  );

  useEffect(() => {
    dispatch(listMyOrders(page));
  }, [dispatch, page]);

  const handlePageChange = (data) => {
    setPage(data.selected + 1);
  };

  console.log("orders", orders);
  // const calculateAmounts = (order) => {
  //   const explodAmount = order.owner_amount * (order.total_price - order.total_sales_tax) / order.total_price;
  //   return {
  //     myAmount: order.total_price.toFixed(2),
  //     explodAmount: explodAmount.toFixed(2),
  //     totalAmount: order.merchant_amount.toFixed(2),
  //   };
  // };

  const calculateAmounts = (order) => {
    return {
      myAmount: order.total_price.toFixed(2),
      explodAmount: order.owner_amount.toFixed(4),
      totalAmount: order.merchant_amount.toFixed(4),
    };
  };

  return (
    <Card>
      {loading ? (
        <div className="mt-3">
          <div className="my-5 row justify-content-center">
            <Loader />
          </div>
        </div>
      ) : error ? (
        <div className="mt-3">
          <div className="my-5 row justify-content-center">
            <Message variant="danger">{error}</Message>
          </div>
        </div>
      ) : (
        <div className="mt-3">
          <div>
            <div className="mx-3">
              <h3>Total Sales</h3>
            </div>
            <div className="row mt-3">
              <div className="col-lg-12 mx-auto">
                {orders &&
                  orders.map((order) => {
                    const { myAmount, explodAmount, totalAmount } =
                      calculateAmounts(order);
                    return (
                      <div className="mt-3" key={order._id}>
                        <div className="row">
                          <div className="col-lg-12 px-5">
                            <div>
                              <h4>
                                <span>
                                  Order ID &mdash; <b>{order.order_track_id}</b>
                                </span>
                              </h4>
                              <span>My Amount &mdash; {formatPrice(myAmount)}</span>
                            </div>
                            <div>
                              <h6 className="mb-2 d-flex justify-content-between">
                                <small>
                                  Explod Amount &mdash; {formatPrice(explodAmount)}
                                  <br />
                                  Total Amount &mdash; {formatPrice(totalAmount)}
                                </small>
                              </h6>
                              <span>
                                <Link
                                  className="text-muted"
                                  to={`/order/${order._id}`}
                                >
                                  View Order
                                </Link>
                              </span>
                            </div>
                          </div>
                        </div>
                        <hr />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <ReactPaginate
              previousLabel={"<<"}
              nextLabel={">>"}
              breakLabel={"..."}
              pageCount={pages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              forcePage={page - 1} // zero-based index for ReactPaginate
              containerClassName={"pagination"}
              activeClassName={"active"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              nextClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
            />
          </div>
        </div>
      )}
    </Card>
  );
};

export default MyOrders;
